import { connect } from 'react-redux';
import CrmAutocompleteChoices from '../../../../components/Share/UprezForm/CrmAutocompleteChoices';

export default connect()(CrmAutocompleteChoices);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/UprezForm/CrmAutocompleteChoices/index.tsx